function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { Fragment, useMemo } from "react";
import FormElement from "../../FormElement/FormElement";
import { normalizeMessages } from "../normalizeMessages/index";
export function FieldMessages(param) {
    var messages = param.messages, fieldErrors = param.fieldErrors, readOnlyField = param.readOnlyField, droppedTestID = param['data-cvent-id'], _testID = param.testID, testID = _testID === void 0 ? droppedTestID : _testID, _fieldTools = param.fieldTools, fieldTools = _fieldTools === void 0 ? {} : _fieldTools, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl;
    var ref = useMemo(function() {
        return normalizeMessages(messages);
    }, [
        messages
    ]), infoMessages = ref.info, errorMessages = ref.error, readOnlyMessages = ref.readOnly;
    if (typeof messages === 'function') {
        var ref1;
        return (ref1 = messages(_objectSpread({}, fieldTools, {
            readOnlyField: readOnlyField,
            fieldErrors: fieldErrors
        }))) !== null && ref1 !== void 0 ? ref1 : null;
    }
    return readOnlyField ? _jsx(FormattedMessages, {
        testID: testID,
        messages: readOnlyMessages,
        type: "info",
        isRtl: isRtl
    }) : _jsxs(Fragment, {
        children: [
            infoMessages && _jsx(FormattedMessages, {
                testID: testID,
                messages: infoMessages,
                type: "info",
                isRtl: isRtl
            }),
            errorMessages && _jsx(FormattedMessages, {
                testID: testID,
                messages: errorMessages,
                type: "error",
                isRtl: isRtl
            }),
            fieldErrors && _jsx(FormattedMessages, {
                testID: testID ? "".concat(testID, "-validation") : undefined,
                messages: fieldErrors,
                type: "error",
                isRtl: isRtl
            })
        ]
    });
}
export function FormattedMessages(_param) {
    var _messages = _param.messages, messages = _messages === void 0 ? [] : _messages, _type = _param.type, type = _type === void 0 ? 'info' : _type, testID = _param.testID, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, propDrop = _objectWithoutProperties(_param, [
        "messages",
        "type",
        "testID",
        "isRtl"
    ]);
    var messageElements = useMemo(function() {
        if (Array.isArray(messages)) {
            return messages.reduce(function(accumulator, message, index) {
                if (typeof message !== 'undefined') {
                    return _toConsumableArray(accumulator).concat([
                        _createElement(FormElement.Message, _objectSpread({}, propDrop, {
                            testID: testID ? "".concat(testID, "-").concat(type, "-").concat(index) : undefined,
                            key: index,
                            type: type,
                            text: message,
                            isRtl: isRtl
                        }))
                    ]);
                }
                return accumulator;
            }, []);
        } else if (typeof messages === 'string') {
            return _jsx(FormElement.Message, _objectSpread({}, propDrop, {
                testID: testID ? "".concat(testID, "-").concat(type) : undefined,
                type: type,
                text: messages,
                isRtl: isRtl
            }));
        }
        return null;
    }, [
        isRtl,
        messages,
        propDrop,
        testID,
        type
    ]);
    return _jsx(Fragment, {
        children: messageElements
    });
}
